<template>
  <div class="DSInputPhoneCountriesList">
    <div class="DSInputPhoneCountriesList__desktop-container">
      <div
        class="DSInputPhoneCountriesList__desktop"
        :class="{ visible: state.theVisible }"
      >
        <div class="DSInputPhoneCountriesList__desktop__filter">
          <hr-input
            ref="inputFilter"
            v-model="state.filter"
            class="DSInputPhoneCountriesList__desktop__filter__input"
            data-test-id="hr-input-phone-countries-list-query"
            @update="filterCountry"
          >
            <template v-slot:icon>
              <co-icon
                :class="{ clickable: state.filter }"
                class="hr-input-phone_icon--search"
                @click="clearFilter"
                :name="state.filter ? 'close' : 'search'"
              />
            </template>
          </hr-input>
        </div>

        <!-- TODO: create DSList component to abstract this implementation -->
        <div class="DSInputPhoneCountriesList__desktop__list">
          <div
            v-for="(country, index) in state.countriesFiltered"
            :key="index"
            class="DSInputPhoneCountriesList__desktop__list__country"
            data-test-id="hr-input-phone-countries-list-country"
            @click="selectCountry(country)"
          >
            <div
              class="DSInputPhoneCountriesList__desktop__country__flag"
            ></div>
            <div class="DSInputPhoneCountriesList__desktop__country__name">
              {{ country.name }}
            </div>
            <div class="DSInputPhoneCountriesList__desktop__country__code">
              ({{ country.dial_code }})
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, watch, ref } from 'vue';
import HrInput from '@/components/hr-input.vue';
import { CoIcon } from '@deputy/copilot2';
export default {
  name: 'hr-input-phone-countries-list',
  components: { HrInput, CoIcon },
  props: {
    value: {
      type: Object,
      default: null,
      description: `field value`,
    },
    visible: {
      type: Boolean,
      default: false,
      description: `visibility`,
    },
    countries: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  emits: ['update:value'],
  setup(props, { emit }) {
    const state = reactive({
      countriesFiltered: props.countries,
      theVisibleModal: false,
      theVisible: false,
      filter: null,
    });
    const inputFilter = ref(null);
    watch(
      () => props.visible,
      () => {
        setVisible();
      }
    );

    setVisible();

    function selectCountry(value) {
      emit('update:value', value);
      close();
    }

    function filterCountry(value) {
      state.countriesFiltered = props.countries.filter((country) =>
        country.name.toLowerCase().match(value)
      );
    }

    function clearFilter() {
      if (!state.filter) {
        return true;
      }

      state.filter = null;
      state.countriesFiltered = props.countries;
    }
    function focus() {
      inputFilter?.value?.focus();
    }
    function close() {
      state.theVisible = false;
      state.theVisibleModal = false;
      emit('visible', false);
    }
    function setVisible(opt) {
      state.theVisibleModal = false;
      state.theVisible = opt !== true || opt !== false ? props.visible : opt;

      if (state.theVisible) {
        focus();
      }
    }

    return {
      state,
      inputFilter,
      selectCountry,
      filterCountry,
      clearFilter,
    };
  },
};
</script>

<style scoped>
.DSInputPhoneCountriesList {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.DSInputPhoneCountriesList__list {
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 2px;
  flex-grow: 1;
  flex: 20;
  overflow: auto;
  height: 100%;
}

.DSInputPhoneCountriesList__filter {
  width: 100%;
  flex: 1;
}

.DSInputPhoneCountriesList__list__country {
  cursor: pointer;
}

.DSInputPhoneCountriesList__list__country div {
  display: inline-block;
}

/* Desktop version */
.DSInputPhoneCountriesList__desktop {
  display: none;
  position: absolute;
  z-index: 2;
  top: 0;
  background: #fff;
  width: 100%;
}

.DSInputPhoneCountriesList__desktop.visible {
  display: block;
}

.DSInputPhoneCountriesList__desktop__list {
  max-height: 120px;
  overflow: auto;
  border: 1px solid #ccc;
  border-radius: 0px 0px 5px 5px;
}

.DSInputPhoneCountriesList__desktop__list__country {
  border-bottom: 1px solid #ccc;
  padding: 5px;
  cursor: pointer;
}

.DSInputPhoneCountriesList__desktop__list__country div {
  display: inline-block;
}

.DSInputPhoneCountriesList__desktop__filter {
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 13px 10px 20px 10px;
}

.DSInputPhoneCountriesList__desktop__filter__input .DSIcon.clickable,
.DSInputPhoneCountriesList__filter__input .DSIcon.clickable {
  cursor: pointer;
}

.DSInputPhoneCountriesList__desktop-container {
  position: relative;
  width: 100%;
}

.DSInputPhoneCountriesList__desktop__list__country:last-of-type {
  border-bottom: none;
}

.hr-input-phone_icon--search {
  width: 20px !important;
  height: 20px !important;
  margin-top: 15px !important;
}
</style>
